export default __webpack_public_path__ + "images/assets/6522cc3a024bde027f036fb83158ac4a.svg";